// extracted by mini-css-extract-plugin
module.exports = {"contracts":"RfpAnalysisPage_contracts__2fsVB","contractsContainer":"RfpAnalysisPage_contractsContainer__ROubK","right":"RfpAnalysisPage_right__327an"};